<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="channels" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="channelId"
  selectionMode="single" [(selection)]="channel" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end">
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <!--<button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
      (click)="getCMPullPropertiesStatusRS()">Refresh Channels</button>-->

      <!--add new-->
      <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
      (click)="onOpenFormAdd()">New Channel +</button>
    </span>
  </div>
</ng-template>
<ng-template pTemplate="header">
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
  <tr>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.shortTermRentalId', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'channelProviderId', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'channelId', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyName', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'channelPropId', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'publishCalendar', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'publishAddress', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'acceptBookingsOnline', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'rateAdjustmentPercent', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'rateAdjustmentAmount', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'flatFeeAdjustmentAmount', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'dailyFeeAdjustmentAmount', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'channelListingStatus', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'channelRateStatus', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'channelAvailStatus', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'channelContentStatus', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'syncEnabled', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-channel>
  <tr [pSelectableRow]="channel">
    <td>{{channel.shortTermRentalId}} </td>
    <td>{{channel.propertyCode}}</td>
    <td>{{getChannelProviderName(channel)}}</td>
    <td>{{channel.channelId}} </td>
    <td>{{channel.name}}</td>
    <td>{{channel.description}}</td>
    <td>{{getStatusName(channel)}}</td>
    <td>{{channel.propertyName}}</td>
    <td>{{channel.channelPropId}} </td>
    <td>{{channel.publishCalendar}}</td>
    <td>{{channel.publishAddress}}</td>
    <td>{{channel.acceptBookingsOnline}}</td>
    <td>{{channel.rateAdjustmentPercent}}</td>
    <td>{{channel.rateAdjustmentAmount}}</td>
    <td>{{channel.flatFeeAdjustmentAmount}}</td>
    <td>{{channel.dailyFeeAdjustmentAmount}}</td>
    <td>{{channel.channelListingStatus}} </td>
    <td>{{channel.channelRateStatus}} </td>
    <td>{{channel.channelAvailStatus}} </td>
    <td>{{channel.channelContentStatus}} </td>
    <td>
      @if (channel.syncEnabled === false) {
        <span style="color:#856404;font-weight:600;">⚠ OFF</span>
      } @else {
        <span style="color:#28a745;">✓ ON</span>
      }
    </td>
    <td><span style="float:none">
      <a>
        <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
        (click)="onOpenFormEdit(channel)">edit</mat-icon>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>